import vuexStore from "@/store/customSaveStore";
import { storageRecommendation } from "../../recommendation/storage/store";

export const datasourceElectronicStorage = vuexStore({
  namespaced: true,
  path: "/datasource-electronic-storage",
  state: {
    editedDatasource: null,
    editedElectronicStorage: null,
    ...storageRecommendation.state,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
    editedElectronicStorage: (state) => state.editedElectronicStorage,
    ...storageRecommendation.getters,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
    editedElectronicStorage: (state, value) => (state.editedElectronicStorage = value),
    ...storageRecommendation.mutations,
  },
  actions: {
    ...storageRecommendation.actions,
  },
});

export const organizationElectronicStorage = vuexStore({
  namespaced: true,
  path: "/electronic-storage",
});
